import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Customer } from "models";

const sortCustomers = (customers: Customer[]) => customers.sort((a, b) => a.customer_type - b.customer_type);

export const useSearchCustomerByCarQuery = (regNr: string) => {
  const { selectedLocation } = useSelectedLocation();

  return useTypedQuery({
    queryKey: AppointmentsQueryKeys.searchCustomersByCar,
    queryFn: async ({ baseUrl, endpoint }) =>
      (await ApiInstance.post(endpoint, { reg_nr: regNr, dealer_location_id: selectedLocation?.id }, baseUrl)).data.customers ?? [],
    enabled: Boolean(regNr),
    select: sortCustomers
  });
};
